import {
  formatBundleReplacementNumber,
  formatBundleReplacementUnits,
} from '../../../lib/bundleReplacementShiftHelpers';

export function BundleReplacementShiftSummaryBar({ summary }) {
  if (!summary) return null;

  const cards = [
    { label: 'Bundle SKUs', value: formatBundleReplacementNumber(summary.bundleCount) },
    { label: 'Replacement SKUs', value: formatBundleReplacementNumber(summary.replacementCount) },
    { label: 'Bundle component demand', value: formatBundleReplacementUnits(summary.componentUnits) },
    { label: 'Shifted bundle demand', value: formatBundleReplacementUnits(summary.shiftedUnits) },
    { label: 'Exceptions', value: formatBundleReplacementNumber(summary.exceptionCount) },
  ];

  return (
    <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-5">
      {cards.map(card => (
        <div key={card.label} className="rounded-md border border-gray-200 bg-white px-3 py-2">
          <p className="text-[11px] uppercase tracking-[0.12em] text-gray-500">{card.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
